import { render, staticRenderFns } from "./TrangSuaDonVi.vue?vue&type=template&id=3aa67c76&"
import script from "./TrangSuaDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangSuaDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports